function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .twitter-tweet {\n    margin: 20px auto;\n  }\n  \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { createGlobalStyle } from 'styled-components';
export default createGlobalStyle(_templateObject());